import { render } from "./ContActions.vue?vue&type=template&id=35c60880&scoped=true"
import script from "./ContActions.vue?vue&type=script&lang=js"
export * from "./ContActions.vue?vue&type=script&lang=js"

import "./ContActions.vue?vue&type=style&index=0&id=35c60880&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c60880"]])

export default __exports__